import { faBox } from '@fortawesome/pro-solid-svg-icons/faBox';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faExpand } from '@fortawesome/pro-solid-svg-icons/faExpand';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faShare } from '@fortawesome/pro-solid-svg-icons/faShare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useClientAccountOverview } from '@ukpostbox/client-data';
import { ContentLoader, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { useNavigate } from 'react-router';
import { EndpointError } from '../../_Global/Components/EndpointError';
import { AccountStatEntry } from './AccountStatEntries/AccountStatEntry';

function AccountStats() {
	const navigate = useNavigate();
	const { data, status, error } = useClientAccountOverview();
	const { t } = useTranslation();

	return (
		<>
			<h6 className='sub-heading mb-xs'>{t('accountStats.title')}</h6>
			{status === 'error' && <EndpointError {...error} />}
			<div className='user-account-stats'>
				{status === 'pending' && (
					<>
						<ContentLoader round childCount={1} childHeight='18.8em' />
						<ContentLoader round childCount={1} childHeight='18.8em' />
						<ContentLoader round childCount={1} childHeight='18.8em' />
						<ContentLoader round childCount={1} childHeight='18.8em' />
						<ContentLoader round childCount={1} childHeight='18.8em' />
						<ContentLoader round childCount={1} childHeight='18.8em' />
					</>
				)}
				{status !== 'pending' && status !== 'error' && (
					<>
						<AccountStatEntry
							label={t('accountStats.labels.mail')}
							value={data?.counts?.unreadLetterEnvelopeScanCount}
							badgeLabel={t('status.new')}
							icon={<FontAwesomeIcon icon={faEnvelope} />}
							callback={() =>
								navigate('./mail/all', {
									state: { folderId: 8, includeFolderAssigned: true, unreadStatus: 1, mailType: 1 },
								})
							}
						/>
						<AccountStatEntry
							label={t('accountStats.labels.mailScans')}
							value={data?.counts?.unreadLetterContentScanCount}
							badgeLabel={t('status.new')}
							icon={<FontAwesomeIcon icon={faExpand} />}
							callback={() =>
								navigate('./mail/all', {
									state: { folderId: 8, includeFolderAssigned: true, unreadStatus: 2, mailType: 1 },
								})
							}
						/>
						<AccountStatEntry
							label={t('accountStats.labels.parcels')}
							value={data?.counts?.unreadParcelEnvelopeScanCount}
							badgeLabel={t('status.new')}
							icon={<FontAwesomeIcon icon={faBox} />}
							callback={() =>
								navigate('./mail/all', {
									state: { folderId: 8, includeFolderAssigned: true, unreadStatus: 1, mailType: 0 },
								})
							}
						/>
						<AccountStatEntry
							label={t('accountStats.labels.parcelsScans')}
							value={data?.counts?.unreadParcelContentScanCount}
							badgeLabel={t('status.new')}
							icon={
								<div className='icon-stack'>
									<FontAwesomeIcon icon={faExpand} />
									<FontAwesomeIcon icon={faBox} />
								</div>
							}
							callback={() =>
								navigate('./mail/all', {
									state: { folderId: 8, includeFolderAssigned: true, unreadStatus: 2, mailType: 0 },
								})
							}
						/>
						<AccountStatEntry
							label={t('accountStats.labels.sends')}
							value={data?.counts?.pendingSendCount}
							badgeLabel={t('status.processing')}
							icon={<FontAwesomeIcon icon={faPaperPlane} />}
							callback={() => navigate('./mail/sends')}
						/>
						<AccountStatEntry
							label={t('accountStats.labels.forwarding')}
							value={data?.counts?.pendingBatchCount}
							badgeLabel={t('status.processing')}
							icon={<FontAwesomeIcon icon={faShare} />}
							callback={() => navigate('./mail/forwarding-batches', { state: { status: 2 } })}
						/>
					</>
				)}
			</div>
		</>
	);
}

export { AccountStats };
